export enum DataSession {
  USUARIO = '125IIPOOPK512PP2O41P242512KVKMKRVQ040605030ZXCZXWR23T',
  TOKEN = '125IIPOOPK512PP2O41P242512KVKMKRVQ0406050%TY567KMJG40',
  CARRITO = '125IIPOOPK512PP2O41P242512KVKMKRVQ0406050%24ER35YJYJ0',
  CHAT = '125IIPOOPK512PP2O41P242512KVKMKRVQ040605030ZXCZYZR23T',
  CHAT_MSN = '125IIPOOPK512PP2O41P146572KVKMKRVQ040605030ZXCZYZR23T',
}
